import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-link-to-for-table',
  templateUrl: './link-to-for-table.component.html',
  styleUrls: ['./link-to-for-table.component.scss']
})
export class LinkToForTableComponent implements OnInit {

  @Output() actionEmit: EventEmitter<string> = new EventEmitter<string>();
  @Input() value: any;
  authUser: any;

  constructor(private router: Router) {
    this.authUser = JSON.parse(sessionStorage.getItem("authUser"));
  }

  ngOnInit(): void {
  }

  routeTo(e:any) {

    if(e.link) {

      this.router.navigate([e.link]);

    } else if (e.emit!=null && e.emit!="") {

      this.actionEmit.emit(e.emit);

    }
    
  }

  getAppsPermissions(appId,permLevel): boolean {

    let ref = this;
    let ritorno = true;

    if(appId && permLevel) {


      if(ref.authUser && ref.authUser.permessiUtente) {

        ref.authUser.permessiUtente.forEach(p => {

          if (p.idApplicazione==appId && p.permesso >= permLevel) {
            ritorno = false;
          }
          
        });

      }

    }

    return ritorno;

  }

}
